// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {Necessary} from '../types';
import {template} from './template';
import css from './index.inline.styl';

interface InputLabelJsxProps {
  attrs?: {
    'extra-info'?: string;
    'field-id'?: string;
    'help-text'?: string;
    label?: string;
    necessary?: string;
  };
}

export class InputLabel extends Component<EmptyObj, InputLabelJsxProps[`attrs`]> {
  static get attrsSchema(): AttrsSchema<InputLabelJsxProps[`attrs`]> {
    return {
      ...super.attrsSchema,
      label: {type: `string`, default: ``, description: `Label on top that describes the input field`},
      necessary: {type: `string`, enum: Object.values(Necessary), default: Necessary.Default},
      'field-id': {type: `string`, description: `Id of input field, maps to field label for accessibility`},
      'help-text': {
        type: `string`,
        description: `If set, an "info" icon will be shown next to the label. This value will be shown as a tooltip on hover`,
      },
      'extra-info': {
        type: `string`,
        description: `If set, we will show this string next to the label. This is useful to give the user additional context such as which SDK verion a field is supported in`,
      },
    };
  }

  get config() {
    return {
      template,
      css,
      defaultState: {},
      helpers: {},
      useShadowDom: true,
    };
  }
}

export const InputLabelEl = defineAndMakeJsxFactory<InputLabelJsxProps>(`mp-input-label`, InputLabel);
export const InputLabelReact = panel2react<InputLabelJsxProps>(`mp-input-label`, InputLabel);
